import {
    createOptionPicker,
    OptionPicker,
} from '@vfde-brix/ws10/option-picker';
import {
    RedTariff,
    YoungTariff,
} from '@vfde-sails/constants';
import { StateProps } from 'Container/App/interface';
import {
    selectActiveSubscriptionId,
    setSubscription,
} from 'Container/App/slice';
import { useDispatch } from '../store';
import { startAppListening } from 'Container/App/listener';
import { createComponentById } from '@vfde-brix/ws10/core';
import { TARIFF_OPTION_TABS_CONTAINER } from 'Container/App/constants';

const mountTariffOptionPicker = (): OptionPicker | null => {
    const dispatch = useDispatch();

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        const id = target.value as RedTariff | YoungTariff;

        id && dispatch(setSubscription(id));
    };

    const tariffOptionPicker = createComponentById(createOptionPicker, TARIFF_OPTION_TABS_CONTAINER, { onChange });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectActiveSubscriptionId(currentState) !== selectActiveSubscriptionId(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const activeSubscriptionId = selectActiveSubscriptionId(api.getState());

            tariffOptionPicker && updateTariffOptionPicker(tariffOptionPicker, activeSubscriptionId);
        },
    });

    return tariffOptionPicker;
};

/**
 * Update selected tariff option after tariff changed
 */
export const updateTariffOptionPicker = (optionPicker: OptionPicker, activeSubscriptionId: StateProps['activeSubscriptionId']): void => {
    const { items } = optionPicker.getProperties();

    items.forEach(item => {
        item.optChecked = !!activeSubscriptionId && item.stdValue === activeSubscriptionId;
    });

    optionPicker.update({ items });
};

export default mountTariffOptionPicker;
